import Instance from '../Helper/axios';
import { URL, URLTEST, urlLocal } from "../Helper/baseURL";

export const correspondingSender = (phone_number,citizenID) => {
    return Instance.post(URL + "SendParcel/correspondingSender", {
        phone_number,
        citizenID
    });
};
